import { render, staticRenderFns } from "./BillingSuccess.vue?vue&type=template&id=5adb7b9a&scoped=true"
import script from "./BillingSuccess.vue?vue&type=script&lang=js"
export * from "./BillingSuccess.vue?vue&type=script&lang=js"
import style0 from "./BillingSuccess.vue?vue&type=style&index=0&id=5adb7b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adb7b9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer})
